import React from "react";
import { Skeleton } from "antd";

function RingProgressSkeleton() {
    return (
        <div
            className="d-flex align-items-center justify-content-center"
            style={{
                height: "100%", width: "100%"
            }}
        >
            <Skeleton.Avatar
                active
                shape="circle"
                style={{
                    height: "60mm", width: "60mm"
                }}
            />
            <div
                style={{
                    position: "absolute",
                    top: "50%",
                    left: "50%",
                    transform: "translate(-50%,-50%)",
                    height: "50mm",
                    width: "50mm",
                    backgroundColor: "white",
                    borderRadius: "50%"
                }}
                className="d-flex-col justify-content-center align-items-center"
            >
                <Skeleton.Button
                    active
                    shape="round"
                    style={{
                        height: "4mm", width: "6mm"
                    }}
                />
                <Skeleton.Button
                    active
                    shape="round"
                    style={{
                        height: "7mm", width: "40mm"
                    }}
                />
            </div>
        </div>
    );
}

export default RingProgressSkeleton;
